/**
 * @description create question model
 * @date 2019-03-29
 * @author jywang
 */
import React, { PureComponent } from 'react';
import QuestionEdit from '../../components/QuestionEdit';
import WithPublicQuestionController from './controller';
import { Button } from 'antd';
import './index.scss';
@WithPublicQuestionController
class CreateQuestion extends PureComponent<any, any> {
    constructor(props) {
        super(props);
    }
    public render() {
        const { hasClickSubmit } = this.props;
        return (
            <div className="create-question-box">
                <div className="create-question-editor-box">
                    <QuestionEdit type="update"/>
                </div>
                <div className="publicBtn">
                    <Button  disabled={hasClickSubmit} onClick={this.props.submitBtn} type="primary">发布答案</Button>
                </div>
            </div>
        );
    }
}
export default CreateQuestion;
